export default function TestimonialSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-[40%] shrink-0">
            <div className="rounded-3xl overflow-hidden aspect-[4/5] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Genuine%20happy%20woman%20sitting%20in%20bright%20minimalist%20living%20room%20holding%20a%20fashion%20package%2C%20warm%20natural%20daylight%20streaming%20through%20window%2C%20authentic%20lifestyle%20moment%2C%20cream%20and%20beige%20interior%2C%20soft%20portrait%20photography%2C%20shopping%20satisfaction%20theme&width=800&height=1000&seq=testimonial-main-v3-sb&orientation=portrait"
                alt="Happy Superbuy spreadsheet user sharing their experience"
                title="Superbuy Spreadsheet Customer Review"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
          <div className="lg:w-[60%] flex flex-col justify-center">
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-600 mb-4">
              ( Trusted by Shoppers )
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-tight mb-6">
              &ldquo;The Superbuy spreadsheet
              <br />
              <span className="text-foreground-300 font-normal">changed how I shop online&rdquo;</span>
            </h2>
            <blockquote className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 border-l-4 border-primary-300 pl-5 py-1 italic">
              I used to spend hours browsing different stores and comparing prices. Since discovering the Superbuy spreadsheet collection, I&rsquo;ve saved so much time and found products I never would have discovered on my own. The categories are well organized, links are always up to date, and the quality of the items I&rsquo;ve received has been consistently great. Highly recommended for anyone who shops internationally.
            </blockquote>
            <div>
              <p className="text-sm font-semibold text-foreground-800">
                &mdash; Sarah Mitchell
              </p>
              <p className="text-xs text-foreground-400 mt-0.5">
                Verified Superbuy User since 2024
              </p>
            </div>
            <div className="flex items-center gap-3 mt-8">
              <button className="w-10 h-10 rounded-full border border-foreground-200 flex items-center justify-center text-foreground-500 hover:text-foreground-800 hover:border-foreground-400 transition-all cursor-pointer">
                <i className="ri-arrow-left-line"></i>
              </button>
              <button className="w-10 h-10 rounded-full bg-foreground-800 flex items-center justify-center text-background-50 hover:bg-foreground-950 transition-all cursor-pointer">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}